<template>
  <div class="addAssessment">
    <new-head :title="task_id ? '填写评估' : '评估详情'" class="pos-top"> </new-head>

    <div class="infoBox" >
      <div class="item" v-if="task_id">
        <p>应聘者</p>
        <p>{{ applicant_data.applicant_name }}</p>
      </div>
      <div class="item" v-if="task_id">
        <p>应聘部门</p>
        <p>{{ applicant_data.applicant_section }}</p>
        <p>应聘岗位</p>
        <p>{{ applicant_data.position_applied }}</p>
      </div>
      <div class="item" >
        <p>评价人</p>
        <p>{{ applicant_data.user_name || username }}</p>
        <p>应聘人</p>
        <p>{{ applicant_data.applicant_name }}</p>
      </div>
      <div class="item" v-show="task_id">
        <p>附件简历</p>
        <p>
          <a v-if="applicant_data" :href="applicant_data.accessory_url">{{
            applicant_data.accessory_url
          }}</a>
        </p>
      </div>
    </div>

    <el-table
      :data="evaluate_data"
      border
      style="
         {
          width: 100%;
        }
      "
      :header-cell-style="{
        textAlign: 'center',
      }"
    >
      <el-table-column prop="date" label="评价项目">
        <template slot-scope="scope">
          {{ `${scope.row.pro_name} (${scope.row.pro_brief})` }}
        </template>
      </el-table-column>
      <el-table-column prop="name" :label="(type == 1 ? '简历' : '面试') + '评估意见'">
        <template slot-scope="scope">
          <el-input
            :disabled="Boolean(eva_id)"
            size="mini"
            type="textarea"
            autosize
            placeholder="输入意见"
            v-model="scope.row.opinion"
            class="textarea"
          >
          </el-input>
        </template>
      </el-table-column>
      <el-table-column prop="address" label="评分">
        <template slot-scope="scope">
          <el-select
            :disabled="Boolean(eva_id)"
            v-model="scope.row.score"
            placeholder="请评分"
            size="mini"
          >
            <el-option
              v-for="item in fractionList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </template>
      </el-table-column>
    </el-table>
    <div class="tableBox">
      <div>
        <p>评价总分</p>
        <p>{{ applicant_data.score || fraction }}</p>
      </div>
      <div>
        <p>评估意见</p>
        <p>{{ setText() }}</p>
      </div>
      <div>
        <p v-if="type == 1">
          提示： 总分大于等于48分，系统判断为[推荐面试]，否则为[不推荐面试]
        </p>
        <p v-if="type == 2">
          提示： 总分大于等于56分，系统判断为[推荐录用]，否则为[不推荐录用]
        </p>
      </div>
    </div>
    <div v-if="task_id" class="submit" @click="submit">提交</div>
  </div>
</template>

<script>
//
import {
  interviewDetailsApi,
  evaluateDetailsApi,
  resumeProjectApi,
  writeResumeRelsultApi,
  writeInterviewRelsultApi,
} from "@/api/api/resume";
import { Toast } from "vant";
export default {
  data() {
    return {
      task_id: null,
      eva_id: null,
      type: null,
      applicant_data: "",
      evaluate_data: [],
      fractionList: [
        {
          label: "非常不符合(2分)",
          value: "2",
        },
        {
          label: "不符合(4分)",
          value: "4",
        },
        {
          label: "一般(6分)",
          value: "6",
        },
        {
          label: "符合(8分)",
          value: "8",
        },
        {
          label: "非常符合(10分)",
          value: "10",
        },
      ],
      username: null,
      fraction: 0, //创建时 前端自己去计算一个分数总和
    };
  },
  watch: {
    evaluate_data: {
      handler(newValue) {
        let num = 0;
        newValue.forEach((item) => {
          num += Number(item.score);
        });
        this.fraction = num;
      },
      deep: true,
    },
  },
  created() {
    this.task_id = this.$route.query.task_id || null;
    this.eva_id = this.$route.query.eva_id || null;
    this.type = this.$route.query.type || null;
    if (this.task_id) {
      this.getData();
    }
    if (this.eva_id) {
      this.getDetail();
    }
  },
  methods: {
    async getDetail() {
      let res;
      if (this.type == 1) {
        res = await evaluateDetailsApi(this.eva_id);
      } else if (this.type == 2) {
        res = await interviewDetailsApi(this.eva_id);
      }
      let data = res.data.data;
      console.log(data);

      this.applicant_data = data.task;
      this.evaluate_data = data.details;
    },
    //
    async getData() {
      let res = await resumeProjectApi(this.task_id);
      let data = res.data.data;
      console.log(data);
      this.username = data.username;
      this.applicant_data = data.applicant_data;
      data.evaluate_data.forEach((item, i) => {
        item.opinion = "";
        item.score = "";
        this.$set(this.evaluate_data, i, item);
      });
      console.log({ ...this.applicant_data });
    },
    async submit() {
      let flag = false;
      for (let i = 0; i < this.evaluate_data.length; i++) {
        const item = this.evaluate_data[i];
        if (!item.score || !item.opinion) {
          console.log(i);
          flag = true;
          break;
        }
      }
      if (flag) {
        return Toast("请完整填写评估意见表");
      }
      let params = {
        task_id: this.task_id,
        project_score: this.evaluate_data.map((item) => {
          return {
            id: item.id,
            score: item.score,
            opinion: item.opinion,
          };
        }),
      };
      console.log(params);
      let res;
      if (this.type == 1) {
        res = await writeResumeRelsultApi(params);
      } else if (this.type == 2) {
        res = await writeInterviewRelsultApi(params);
      }
      console.log(res);
      if (res.data.errorCode == 0) {
        Toast("提交成功");
        setTimeout(() => {
          this.$router.back();
        }, 500);
      }
    },
    setText() {
      let typeText;
      this.type == 1 ? (typeText = "面试") : (typeText = "录用");
      if (this.eva_id) {
        return this.applicant_data.status == 1 ? "推荐" + typeText : "不推荐" + typeText;
      } else {
        if (this.type == 1) {
          /**
           * 简历筛选结果：总分大于等于48分，系统判断为[推荐面试]，否则为[不推荐面试]
           */
          return this.fraction >= 48 ? "推荐" + typeText : "不推荐" + typeText;
        } else if (this.type == 2) {
          /**
           * 面试评估结果：总分大于等于56分，系统判断为[推荐录用]，否则为[不推荐录用]
           */
          return this.fraction >= 56 ? "推荐" + typeText : "不推荐" + typeText;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-select input {
  padding: 0 !important;
}
/deep/ textarea {
  height: 80px !important;
}
/deep/ .el-table .cell {
  padding: 0 5px;
}
.addAssessment {
  padding: 74px 10px 50px;
}

.infoBox {
  font-size: 14px;
  margin-bottom: 20px;

  .item {
    display: flex;

    p {
      min-height: 40px;
      flex: 1;
      border: 1px solid #acbed1;
      box-sizing: border-box;
      border-spacing: 0;
      border-collapse: collapse;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
      a {
        width: 100%;
        text-align: center;
        word-break: break-all;
      }
    }
  }

  .item:last-child {
    p:nth-child(2) {
      flex: 3.05;
    }
  }
}
.tableBox {
  > div {
    display: flex;
    p {
      min-height: 40px;
      flex: 1;
      border: 1px solid #8a8a8a;
      border-spacing: 0;
      border-collapse: collapse;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 2px;
    }
  }
}

.submit {
  margin: 0 100px;
  margin-top: 20px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #0286ff;
  color: #fff;
}
</style>
